<div class="clear"></div>
<div class="note-form">
  <h4>{{'addNoteText'|translate:translations}}</h4>
  <input [hidden]="true" [(ngModel)]="selectedNote.id" />
  <textarea rows="5" class="open-course-notes" [(ngModel)]="selectedNote.note"></textarea>

  <div mat-dialog-actions class="form-buttons">
    <button class="submit-form-button" [ngClass]="participantClassByRole" [mat-dialog-close]="selectedNote">{{'saveButtonText'|translate:translations}}</button>
    <button class="submit-form-button cancel-button" [ngClass]="participantClassByRole" (click)="onNoClick()">{{'cancelButtonText'|translate:translations}}</button>
  </div>
</div>
